import { captureAnalyticsEvent } from './posthog'

export type SmSessionSource = 'login' | 'session_restore'

export function captureSmUserSessionStarted(props: {
  sm_user_id: string
  session_source: SmSessionSource
  tenant_id?: string | null
}): void {
  captureAnalyticsEvent('sm_user_session_started', {
    sm_user_id: props.sm_user_id,
    session_source: props.session_source,
    ...(props.tenant_id ? { tenant_id: props.tenant_id } : {}),
  })
}

export function captureSmCampaignLaunched(props: {
  campaign_id: string
  sm_user_id?: string | null
  team_member_count?: number
}): void {
  captureAnalyticsEvent('sm_campaign_launched', {
    campaign_id: props.campaign_id,
    ...(props.sm_user_id ? { sm_user_id: props.sm_user_id } : {}),
    ...(props.team_member_count !== undefined
      ? { team_member_count: props.team_member_count }
      : {}),
  })
}
